import React, { useState } from 'react';
import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent, IonButton, IonItem, IonLabel, IonInput, IonTextarea } from '@ionic/react';
import { useHistory } from 'react-router-dom';
import config from '../config'; // Import config

function AddTree() {
  const history = useHistory();
  const [name, setName] = useState('');
  const [species, setSpecies] = useState('');
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');
  const [description, setDescription] = useState('');

  const handleSubmit = () => {
    const tree = { name, species, latitude, longitude, description };
    fetch(`${config.API_BASE_URL}/trees`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify(tree)
    }).then(() => {
      alert('Tree submitted for approval!');
      history.push('/');
    });
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Add a Tree</IonTitle>
          <IonButton slot="end" onClick={() => history.push('/')}>Home</IonButton>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonItem>
          <IonLabel position="stacked">Name</IonLabel>
          <IonInput value={name} onIonChange={e => setName(e.target.value)}></IonInput>
        </IonItem>
        <IonItem>
          <IonLabel position="stacked">Species</IonLabel>
          <IonInput value={species} onIonChange={e => setSpecies(e.target.value)}></IonInput>
        </IonItem>
        <IonItem>
          <IonLabel position="stacked">Latitude</IonLabel>
          <IonInput type="number" value={latitude} onIonChange={e => setLatitude(e.target.value)}></IonInput>
        </IonItem>
        <IonItem>
          <IonLabel position="stacked">Longitude</IonLabel>
          <IonInput type="number" value={longitude} onIonChange={e => setLongitude(e.target.value)}></IonInput>
        </IonItem>
        <IonItem>
          <IonLabel position="stacked">Description</IonLabel>
          <IonTextarea value={description} onIonChange={e => setDescription(e.target.value)}></IonTextarea>
        </IonItem>
        <IonButton expand="block" onClick={handleSubmit}>Submit Tree</IonButton>
      </IonContent>
    </IonPage>
  );
}

export default AddTree;